import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

/**
 * sealy ProductDisplayPage `special_offer` assembly (#33582).
 *
 * FAITHFUL port of the legacy `cms/product_display_page.html` inline render
 * (verified at git dev), which sat inside the `.product-hero` section:
 *
 *     {% for offer in self.special_offer %}
 *         {% if offer.value.offer_link %}<a href="{% pageurl ... %}">{% endif %}
 *         {% image offer.value.offer_badge original as offer_badge %}
 *         <img class="pdp-hero__offer-badge" src="{{ offer_badge.url }}" />
 *         {% if offer.value.offer_link %}</a>{% endif %}
 *     {% endfor %}
 *
 * - The badge `<img>` has NO alt attribute (legacy parity; see the legacy
 *   `TODO ... #13290` comment, which -- being an HTML comment -- is dropped
 *   here since JSX cannot emit one).
 * - `offer_link` resolves through the serialized PageChooserBlock `url` (the
 *   same routed URL `{% pageurl %}` produced).
 * - The badge uses the `original` rendition the legacy `{% image %}` requested
 *   (exposed via `extra_client_data_renditions` on `SpecialOfferBlock`); a
 *   missing rendition degrades to `src=""`, exactly what the legacy template
 *   emitted when the `{% image %}` tag could not resolve.
 * - An empty/null StreamField renders nothing (the legacy
 *   `{% if self.special_offer %}` gate).
 */
export const Template = (
    props: Immutable<templates.ProductDisplaySpecialOfferTemplate>,
): React.JSX.Element | null => {
    const offers = props.page.special_offer?.value ?? [];
    if (offers.length === 0) {
        return null;
    }
    return (
        <>
            {offers.map((offer) => {
                const badge = (
                    // TODO(#13290): needs a link title / accessible name since
                    // the link content is an image with no alt (legacy parity).
                    <img
                        className="pdp-hero__offer-badge"
                        src={
                            offer.value.offer_badge?.renditions["original"]
                                ?.url ?? ""
                        }
                    />
                );
                const link = offer.value.offer_link;
                if (link) {
                    return (
                        <a key={offer.id} href={link.url}>
                            {badge}
                        </a>
                    );
                }
                return <React.Fragment key={offer.id}>{badge}</React.Fragment>;
            })}
        </>
    );
};
